import type { FC } from 'react';
import { useIsNewDesignActive } from 'src/pages/new-design/is-new-design';
import { cn } from 'src/utils/cn';

export const CheckedIcon: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const isNewDesignActive = useIsNewDesignActive();

  const errorColor = isNewDesignActive
    ? 'var(--color-border-support-error-subdued)'
    : 'var(--color-legacy-error)';
  const disabledColor = isNewDesignActive
    ? 'var(--color-border-surface-disabled)'
    : 'var(--color-legacy-inactive)';
  const disabledBgColor = isNewDesignActive
    ? 'var(--color-background-surface-disabled)'
    : 'var(--color-legacy-inactive-lighter)';
  const regularColor = isNewDesignActive
    ? 'var(--color-border-surface-default)'
    : 'var(--color-legacy-brand)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;

  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <g
        fill={primaryColor}
        stroke={disabled ? disabledBgColor : '#fff'}
        strokeWidth="1"
      >
        <rect width="14" height="14" rx="3" stroke="none" />
        <rect
          x="0.25"
          y="0.25"
          width="13.5"
          height="13.5"
          rx="2.75"
          fill="none"
        />
      </g>
      <path
        d="M36,2345l3.045,3.045,5.02-5.02"
        transform="translate(-33 -2339)"
        fill={primaryColor}
        stroke={disabled ? disabledBgColor : '#fff'}
        strokeWidth="2"
      />
    </svg>
  );
};

export const UncheckedIcon: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const isNewDesignActive = useIsNewDesignActive();

  const errorColor = isNewDesignActive
    ? 'var(--color-border-support-error-subdued)'
    : 'var(--color-legacy-error)';
  const errorBgColor = isNewDesignActive
    ? 'var(--color-background-support-error-minimal)'
    : 'var(--color-legacy-error-lighter)';
  const disabledColor = isNewDesignActive
    ? 'var(--color-border-surface-disabled)'
    : 'var(--color-legacy-inactive)';
  const disabledBgColor = isNewDesignActive
    ? 'var(--color-background-surface-disabled)'
    : 'var(--color-legacy-inactive-lighter)';
  const regularColor = isNewDesignActive
    ? 'var(--color-border-surface-default)'
    : 'var(--color-legacy-brand)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;

  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <g
        fill={disabled ? disabledBgColor : error ? errorBgColor : '#fff'}
        stroke={primaryColor}
        strokeWidth="1"
      >
        <rect width="14" height="14" rx="3" stroke="none" />
        <rect
          x="0.25"
          y="0.25"
          width="13.5"
          height="13.5"
          rx="2.75"
          fill="none"
        />
      </g>
    </svg>
  );
};

export const MixedCheck: FC<{
  error?: boolean;
  disabled?: boolean;
}> = ({ error, disabled }) => {
  const isNewDesignActive = useIsNewDesignActive();

  const errorColor = isNewDesignActive
    ? 'var(--color-border-support-error-subdued)'
    : 'var(--color-legacy-error)';
  const disabledColor = isNewDesignActive
    ? 'var(--color-border-surface-disabled)'
    : 'var(--color-legacy-inactive)';
  const regularColor = isNewDesignActive
    ? 'var(--color-border-surface-default)'
    : 'var(--color-legacy-brand)';

  const primaryColor = disabled
    ? disabledColor
    : error
      ? errorColor
      : regularColor;

  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 14 14"
      className={cn(disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
    >
      <g fill={regularColor} stroke={primaryColor} strokeWidth="0.5">
        <rect width="14" height="14" rx="3" stroke="none" />
        <rect
          x="0.25"
          y="0.25"
          width="13.5"
          height="13.5"
          rx="2.75"
          fill={primaryColor}
        />
      </g>
      <path
        d="M3.319,17.434h7.742"
        transform="translate(0 -10)"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
      />
    </svg>
  );
};
